/**
 * Utilitários compartilhados para validar/sanitizar o texto do prontuário
 * (auto_triagem) antes de persistir, enviar ou aceitar reidratação.
 *
 * Vetores cobertos:
 *  - Caracteres invisíveis (zero-width, BOM) que driblam String.trim().
 *  - Texto curto demais para ser um prontuário real.
 *  - Template “só não informado” (caso Beatriz 31/05/2026).
 *
 * IMPORTANTE: a versão server-side em functions/index.js DEVE manter a mesma
 * semântica desta função. Mudanças aqui exigem ajuste lá.
 */

export const ZERO_WIDTH_RE = /[\u200B\u200C\u200D\uFEFF]/g;
export const PRONTUARIO_HEADER_RE = /^\s*(?:📋\s*)?(?:\*\*)?(?:Prontuário|Prontuario)\s+Médico\b/i;
export const NAO_INFORMADO_RE = /n[aã]o informad[oa]/gi;

export const MIN_USEFUL_LENGTH = 60;
/** Acima deste número de “não informado”, tratamos como template vazio. */
export const MAX_NAO_INFORMADO_SLOTS = 7;

export function sanitizeProntuarioText(raw) {
  if (raw == null) return '';
  let s = String(raw);
  s = s.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  s = s.replace(ZERO_WIDTH_RE, '');
  return s.trim();
}

export function getUsefulLength(sanitized) {
  if (!sanitized) return 0;
  return sanitized.replace(/\s+/g, ' ').trim().length;
}

export function countNaoInformadoSlots(sanitized) {
  if (!sanitized) return 0;
  return (String(sanitized).match(NAO_INFORMADO_RE) || []).length;
}

/**
 * Detecta prontuário gerado sem dado clínico real (todos/most slots “não informado”).
 */
export function isClinicallyEmptyProntuario(raw) {
  const sanitized = sanitizeProntuarioText(raw);
  if (!sanitized) return true;

  const naoCount = countNaoInformadoSlots(sanitized);
  if (naoCount >= MAX_NAO_INFORMADO_SLOTS) return true;

  if (/Queixa Principal:?\s*\n?\s*n[aã]o informado/i.test(sanitized)) return true;
  if (/Paciente refere n[aã]o informado/i.test(sanitized)) return true;

  return false;
}

export function isValidProntuarioText(raw) {
  const sanitized = sanitizeProntuarioText(raw);
  if (!sanitized) return false;
  if (getUsefulLength(sanitized) < MIN_USEFUL_LENGTH) return false;
  if (isClinicallyEmptyProntuario(sanitized)) return false;
  return true;
}
